import { render, staticRenderFns } from "./AlarmInfoTable.vue?vue&type=template&id=33d1e3be&scoped=true"
import script from "./AlarmInfoTable.vue?vue&type=script&lang=js"
export * from "./AlarmInfoTable.vue?vue&type=script&lang=js"
import style0 from "./AlarmInfoTable.vue?vue&type=style&index=0&id=33d1e3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d1e3be",
  null
  
)

export default component.exports